import { Checkbox } from '@/components/ui/checkbox'
import { ColumnDef } from '@tanstack/react-table'
import { DataTableColumnHeader } from './data-table-column-header'
import { DataTableRowActions } from './data-table-row-actions'

import { DepartmentWithCount } from '@/interfaces/department'
import { IconCheck, IconX } from '@tabler/icons-react'

export const columns: ColumnDef<DepartmentWithCount>[] = [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && 'indeterminate')
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label='Select all'
        className='translate-y-[2px]'
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label='Select row'
        className='translate-y-[2px]'
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'color',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title='Cor' />
    ),
    cell: ({ row }) => {
      return (
        <div className='flex items-center'>
          <div className='h-4 w-4 rounded-full' style={{ backgroundColor: row.getValue('color') }} />
        </div>
      )
    },
    enableSorting: false,
  },
  {
    accessorKey: 'name',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title='Nome' />
    ),
    cell: ({ row }) => {
      return (
        <div className='flex space-x-2'>
          <span className='max-w-32 truncate font-medium sm:max-w-72 md:max-w-[31rem]'>
            {row.getValue('name')}
          </span>
        </div>
      )
    },
  },
  {
    accessorKey: 'attendantCount',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title='Atendentes associados' />
    ),
    cell: ({ row }) => {
      return (
        <div className='flex w-[100px] items-center'>
          {row.getValue('attendantCount')}
        </div>
      )
    },
    enableSorting: false,
  },
  {
    accessorKey: 'isDefault',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title='Padrão' />
    ),
    cell: ({ row }) => {
      const isDefault = row.getValue('isDefault')
      return (
        <div className='flex w-[100px] items-center'>
          {isDefault ? (
            <>
              <IconCheck className="mr-2 h-4 w-4 text-green-500" />
              <span>Sim</span>
            </>
          ) : (
            <>
              <IconX className="mr-2 h-4 w-4 text-red-500" />
              <span>Não</span>
            </>
          )}
        </div>
      )
    },
    enableSorting: false,
  },
  {
    id: 'actions',
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
]
